import src from "IMAGE";
export default { src, width: 236, height: 72, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAOklEQVR42h3LuQ0AMQgFUZdIgMQhcfVfA/q7dvCymTMz291wd0QERORRVRDRHmbeqoKZPTfMTNzptx8t4yDqBRguKwAAAABJRU5ErkJggg=="};
